import { IPathParams } from '@app/constants/path-params'
import { IFileState } from '@app/interfaces/files'
import { IOrganizationPupilsState } from '@app/interfaces/pupil/organization-pupils'
import OrganizationPupilInfo from '@app/pages/organizations/components/organization-pupils/components/organization-pupil-page/components/organization-pupil-info'
import OrganizationPupilsParents from '@app/pages/organizations/components/organization-pupils/components/organization-pupil-page/components/organization-pupils-parents'
import { removeFile } from '@app/store/actions/files-actions'
import {
  clearOrganizationPupil,
  getOrganizationPupil,
} from '@app/store/actions/organization-pupils-actions'
import axios from 'axios'
import { isEmpty } from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { OrganizationPupilBilling } from './components/organization-pupil-billing'
import { Button, Card } from 'antd'

interface props {
  _pupilsState: IOrganizationPupilsState
  _filesState: IFileState
}

const OrganizationPupilPage: React.FC<props> = ({
  _pupilsState,
  _filesState,
}) => {
  const params: IPathParams = useParams()
  const { pupil, refresh } = _pupilsState
  const { preUploadedPhoto, photo } = _filesState
  const [t] = useTranslation()
  const dispatch = useDispatch()
  const [view, setView] = useState<'info' | 'billing'>('info')

  useEffect(() => {
    const source = axios.CancelToken.source()
    dispatch(
      getOrganizationPupil(
        { data: Number(params.pupilId), source },
        { pupilError: t('pupils.error'), fileError: t('users.errorAvatar') },
      ),
    )
    return () => {
      dispatch(removeFile())
      dispatch(clearOrganizationPupil())
      source.cancel('Component got unmounted')
    }
  }, [refresh])

  const renderTabs = useMemo(() => {
    return (
      <div style={{ display: 'flex', gap: '10px' }}>
        <Button
          onClick={() => setView('info')}
          type={view === 'info' ? 'primary' : 'default'}>
          {t('pupils.pupilInfo')}
        </Button>
        <Button
          onClick={() => setView('billing')}
          type={view === 'billing' ? 'primary' : 'default'}>
          {t('pupils.pupilBalance')}
        </Button>
      </div>
    )
  }, [view, t])

  // return (
  //   <React.Fragment>
  //     {!isEmpty(pupil) && (
  //       <div>
  //         <OrganizationPupilInfo
  //           avatar={photo}
  //           preload={preUploadedPhoto}
  //           _pupil={pupil}
  //         />
  //         <OrganizationPupilsParents _pupils={pupil} />
  //       </div>
  //     )}
  //   </React.Fragment>
  // )

  return (
    <React.Fragment>
      <Card
        style={{
          padding: '10px',
          marginBottom: '10px',
        }}>
        {renderTabs}
      </Card>
      {!isEmpty(pupil) && (
        <>
          {view === 'info' && (
            <div>
              <OrganizationPupilInfo
                avatar={photo}
                preload={preUploadedPhoto}
                _pupil={pupil}
              />
              <OrganizationPupilsParents _pupils={pupil} />
            </div>
          )}
          {view === 'billing' && <OrganizationPupilBilling _pupil={pupil} />}
        </>
      )}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    _pupilsState: state.organizationPupils,
    _filesState: state.files,
  }
}

export default connect(mapStateToProps)(OrganizationPupilPage)
